import { Table, Tag, Typography } from "antd";
import { MazakaBull } from "apps/Common/MazakaBull";
import { FC, Key, useEffect, useState } from "react";

const PortFolioUsers: FC<{ data: any; selectedRowKeys:Key[],setSelectedRowKeys:any }> = ({ data, selectedRowKeys,setSelectedRowKeys }) => {
  const { Text } = Typography;
  const [allUsers,setAllUsers] = useState<any>([])

  

  useEffect(()=>{
    if(data)
    {
      const allUser = [...data?.portfolioUser?.map((item:any)=>{
        return{
          ...item,
          isOwner:false
        }
      }) ]
      const ownerStore = {name:data?.userName||""  ,eMail:data?.userEmail||"",phoneNumber:data?.userPhone,isOwner:true}
     
    setAllUsers([ownerStore, ...allUser]);
    }
  },[data])


  const columns = [
    {
      title: "Adı Soyadı",
      render:(value:string,record:any)=>{
        return `${record?.name||""} ${record?.surname||""}`
      }
    },
    {
      title: "Telefon",
      dataIndex: "phoneNumber",
      render: (text: string) => <Text className="!text-indigo-500">{text}</Text>,
    },
    {
      title: "E-Posta",
      dataIndex: "eMail",
      render: (email: string) => <Text className="!text-indigo-500">{email}</Text>,
    },
    {
      title: "Mağaza",
      render: (_: any,) => (
        <Tag color="green">{data?.storeName || ""}</Tag>
      ),
    },
    {
      title: "Mağaza Sahibi",
      dataIndex:"isOwner",
      render: (status: boolean) => (
        <MazakaBull type={status?"Success":"Error"}  />
      ),
    },
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys: React.Key[]) => {
      setSelectedRowKeys(newSelectedRowKeys);
    },
  };



  return (
    <Table
      rowKey={"id"}
      columns={columns}
      dataSource={allUsers}
      pagination={false}
      rowSelection={rowSelection}
    />
  );
};

export default PortFolioUsers;
